export const REVIEW_CODE_KEYS: Record<string, string> = {
  byom_model: 'review.seat.reason.byom_model',
  credits_exhausted: 'review.error.credits_exhausted',
  human_seat: 'review.seat.reason.human_seat',
  model_delisted: 'review.seat.reason.model_delisted',
  model_unpriced: 'review.seat.reason.model_unpriced',
  review_context_limit: 'review.error.review_context_limit',
  review_pending_message: 'review.error.review_pending_message',
  review_turn_cap_reached: 'review.error.review_turn_cap_reached',
}

const NEW_SESSION_CODES: ReadonlySet<string> = new Set([
  'review_turn_cap_reached',
  'review_context_limit',
])

export function reviewCodeKey(code: string | null | undefined): string {
  if (code && Object.hasOwn(REVIEW_CODE_KEYS, code)) {
    return REVIEW_CODE_KEYS[code]
  }
  return 'review.error.generic'
}

export function isNewSessionCode(code: string | null | undefined): boolean {
  return typeof code === 'string' && NEW_SESSION_CODES.has(code)
}
